export default "__VITE_ASSET__DxVo$CVn__"